import React from 'react'
import Spinner from 'components/Spinner'
import { ShareForSettingsModal } from '../types'
import { useGetShareMembershipsQuery } from 'gqlTypes'
import { Wrapper } from './ShareMemberships.styles'
import { Box } from 'components/Box'
import InfiniteList, { handleFetchMore } from 'components/InfiniteList'
import { ShareMember } from '../ShareMember'

export type ShareForMembershipList = Pick<
  ShareForSettingsModal,
  | 'identifier'
  | 'allowedPrivateAccessLevels'
  | 'userCanUpdateCommentsEnabled'
  | 'libraryEnabled'
  | 'workspaceAccessLevel'
  | 'workspaceCommentsEnabled'
  | 'isDraft'
>

interface MembershipListProps {
  share: ShareForMembershipList
}

const ShareMemberships = ({ share }: MembershipListProps) => {
  const { error, data, loading, fetchMore } = useGetShareMembershipsQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      shareIdentifier: share.identifier,
    },
  })

  const memberships = data?.share?.memberships?.entries || []

  if (error) {
    return (
      <Box my={4} color="red">
        Memberships failed to load
      </Box>
    )
  }

  if (loading && memberships.length === 0) {
    return <Spinner.Flex my={4} primary />
  }

  if (memberships.length === 0) {
    return <Box my={4}>People added to the document will appear here</Box>
  }

  const after = data?.share?.memberships?.meta.after || null

  return (
    <Wrapper data-testid="membership-list">
      <InfiniteList
        onLoadMore={handleFetchMore(
          fetchMore,
          ['share', 'memberships', 'entries'],
          { after }
        )}>
        {memberships.map(membership => (
          <ShareMember
            key={membership.identifier}
            share={share}
            member={membership}
          />
        ))}
      </InfiniteList>
    </Wrapper>
  )
}

export default ShareMemberships
